module.exports = __webpack_public_path__ + "img/svg.4a96967e.svg";